// COPYRIGHT SMARTTRACK

/**
 * Requires
 */

// Babel
require('core-js/stable');
require('regenerator-runtime/runtime');

// Modules
const externalUserModule = require('../modules/external-user');
const navigationModule = require('../modules/navigation');


/**
 * Handlers
 */

const expandContractRoleDetail = () => {

	// Get action
	const action = document.getElementById('expand-contract-text');
	if (action.getAttribute('data-expanded') === 'true') {

		// Set contracted state
		action.innerHTML = 'Find out more';
		action.setAttribute('data-expanded', 'false');

		// Contract elements
		const elements = document.getElementsByName('role-detail');
		for (let i = 0; i < elements.length; i += 1) {
			$(elements[i]).animate({
				height: 0
			}, 400, function () {
				$(this).height('0px');
			});
		}
	} else {

		// Set expanded state
		action.innerHTML = 'Show less';
		action.setAttribute('data-expanded', 'true');

		// Expand elements
		const elements = document.getElementsByName('role-detail');
		for (let i = 0; i < elements.length; i += 1) {
			$(elements[i]).animate({
				height: $(elements[i]).get(0).scrollHeight
			}, 400, function () {
				$(this).height('auto');
			});
		}
	}
};


/**
 * Action Handlers
 */

function createActionHandlers() {

	// Handle click on find out more button
	$('#find-out-more').click(() => {
		expandContractRoleDetail();
	});
}


/**
 * Init
 */

// Initialize navigation
navigationModule.initialize();

// Handle reset onboarding
externalUserModule.handleResetOnboarding();

// Create action handlers
createActionHandlers();
